<template>
  <v-app class="DashboardLayout" v-bind="theme">
    <AppLeftBar id="AppLeftBar" />

    <v-app-bar
      id="MainAppBar"
      elevation="0"
      class="no-pointer-events no-bg"
      :clipped-left="leftDrawer.clipped"
      :clipped-right="rightDrawer.clipped"
      fixed
      app
      :class="{
        'drawer-closed': !leftDrawer.opened,
        'no-bg': currentUser.role === 'tourism-operator',
        white: currentUser.role === 'admin',
      }"
    >
      <router-link :to="{ name: 'dashboard' }" class="app-logo">
        <img src="@assets/images/app-logo1@2x.png" alt />
      </router-link>

      <v-app-bar-nav-icon
        class="left-drawer-icon pointer-events-all"
        color="black"
        @click.stop="openLeftDrawer()"
      />
      <v-spacer />
      <v-app-bar-nav-icon
        v-if="currentUser.role === 'tourism-operator'"
        class="left-drawer-icon pointer-events-all"
        color="black"
        @click.stop="openRightDrawer()"
      >
        <v-icon>$dots</v-icon>
      </v-app-bar-nav-icon>

      <v-btn
        class="pointer-events-all no-bg-hover no-bg"
        :ripple="false"
        text
        v-else
        @click="openRightDrawer()"
      >
        Welcome,
        {{
          currentUser &&
            currentUser.first_name &&
            currentUser.first_name.capitalize()
        }}
        <v-avatar class="ml-2" size="42">
          <v-img
            :src="getMedia(currentUser)"
            :alt="
              currentUser &&
                currentUser.first_name &&
                currentUser.first_name.excerpt(2, '')
            "
            lazy-src="/placeholder.jpg"
          />
        </v-avatar>
      </v-btn>
    </v-app-bar>
    <v-content
      id="PageContent"
      class="border-radius-layout pb-24"
      app
      style="background-color: #fff"
      :class="leftDrawer.opened ? '' : 'drawer-closed'"
    >
      <router-view id="PageWrapper" />
    </v-content>
    <AppRightBar />
  </v-app>
</template>

<script>
import '@assets/scss/dashboard.scss';
export default {
  name: 'App',
  components: {
    AppLeftBar: () => import('@components/AppLeftBar'),
    AppRightBar: () => import('@components/AppRightBar'),
  },
  data() {
    return {
      dark: false,
    };
  },
  watch: {
    dark(isDark) {
      this.$vuetify.theme.dark = isDark;
    },
  },
  computed: {
    theme() {
      return this.dark
        ? { dark: true, light: false }
        : { light: true, dark: false };
    },
  },
  methods: {
    openRightDrawer() {
      this.rightDrawer.permanent = !this.rightDrawer.permanent;
      this.rightDrawer.opened = !this.rightDrawer.opened;
    },
    openLeftDrawer() {
      this.leftDrawer.manuallySwitched = true;
      this.leftDrawer.permanent = !this.leftDrawer.permanent;
      this.leftDrawer.opened = !this.leftDrawer.opened;
    },
  },
};
</script>

<style lang="scss">
.user-avatar {
  .v-responsive__content {
    z-index: -2;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-transform: uppercase;
  }
}

.portalled #LayoutWrapper {
  display: none;
}
</style>
